/* OSO homepage: scroll-linked reveals, image shutters and hero depth.
   Uses native scrolling. No content is hidden and no scroll is intercepted. */
(function () {
  if (!document.documentElement.classList.contains('scroll-reveal-on')) return;
  const main = document.getElementById('MainContent');
  if (!main) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let items = [], hero = null, frame = 0;
  const clamp = value => Math.max(0, Math.min(1, value));
  const ease = value => value * value * (3 - 2 * value);

  function bind() {
    items = [];
    const seen = new Set();
    function add(selector, options) {
      main.querySelectorAll(selector).forEach((el, index) => {
        if (seen.has(el)) return;
        seen.add(el);
        const anchor = el.parentElement;
        el.classList.add('oso-motion-item');
        if (options.image) el.classList.add('oso-motion-image');
        if (options.banner) el.classList.add('oso-motion-banner');
        items.push({el, anchor, index, ...options});
      });
    }
    add('.rich-text', {y:70});
    add('.section-title-rule, .category-grid-header, .feature-cards-header, .corporate-offerings-header', {y:65});
    add('.category-grid-card', {y:100, stagger:24});
    add('.oso-story__image', {y:65, x:-35, image:true});
    add('#practitioner-tools .category-grid-card-image', {y:0, image:true});
    add('.oso-story__content', {y:55, x:50});
    add('.feature-cards-card', {y:90, stagger:28});
    add('.single-product-promo-inner', {y:60});
    add('.follow-gallery-header', {y:65});
    add('.follow-gallery--header .follow-gallery-item', {y:0, image:true});
    add('.follow-gallery-track', {y:60});
    add('.accordion-wrapper', {y:45});
    add('.video-content--inner', {y:60});
    const slides = main.querySelectorAll('.slidershow');
    hero = slides[0] || null;
    if (hero) hero.classList.add('oso-motion-hero');
    Array.from(slides).slice(1).forEach(el => {
      el.classList.add('oso-motion-banner');
      items.push({el,anchor:el.parentElement,y:0,banner:true,index:0});
    });
    schedule();
  }

  function update() {
    frame = 0;
    const mobile = innerWidth < 750;
    const vh = innerHeight;
    const rects = new Map();
    const measurements = items.map(item => {
      if (!rects.has(item.anchor)) rects.set(item.anchor,item.anchor.getBoundingClientRect());
      const rect = rects.get(item.anchor);
      const naturalTop = mobile && item.stagger ? item.el.getBoundingClientRect().top - (parseFloat(item.el.style.getPropertyValue('--osh-y')) || 0) : rect.top;
      return {item,rect,naturalTop};
    });
    const heroRect = hero && hero.getBoundingClientRect();
    measurements.forEach(({item,rect,naturalTop}) => {
      const focused = item.el.contains(document.activeElement);
      const stop = reduced.matches || focused;
      const top = naturalTop;
      const p = stop ? 1 : ease(clamp((vh * .98 - top) / (vh * .72)));
      const left = 1 - p;
      const amount = (item.y || 0) + (mobile ? 0 : (item.stagger || 0) * (item.index % 4));
      item.el.style.setProperty('--osh-y',(left * amount * (mobile ? .45 : 1)).toFixed(2)+'px');
      item.el.style.setProperty('--osh-x',(left * (mobile ? 0 : (item.x || 0))).toFixed(2)+'px');
      item.el.style.setProperty('--osh-opacity',(1-left*.18).toFixed(3));
      if (item.image) {
        item.el.style.setProperty('--osh-clip',(left*25).toFixed(2)+'%');
        item.el.style.setProperty('--osh-zoom',(1+left*.1).toFixed(4));
      }
      if (item.banner) item.el.style.setProperty('--osh-inset',(left*(mobile?2:6)).toFixed(2)+'%');
    });
    if (heroRect) {
      const p = reduced.matches ? 0 : clamp(-heroRect.top / Math.max(1,heroRect.height));
      hero.style.setProperty('--osh-hero-y',(p*(mobile?32:110)).toFixed(2)+'px');
      hero.style.setProperty('--osh-hero-scale',reduced.matches?'1':(1.025+p*.035).toFixed(4));
      hero.style.setProperty('--osh-copy-y',(-p*(mobile?12:36)).toFixed(2)+'px');
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('pageshow',schedule);
  main.addEventListener('focusin',schedule);
  main.addEventListener('focusout',schedule);
  reduced.addEventListener('change',schedule);
  document.addEventListener('shopify:section:load',bind);
  document.addEventListener('shopify:section:unload',bind);
  document.addEventListener('shopify:section:reorder',bind);
  bind();
})();
